import React from 'react';

const SchoolPolicy = () => {
  return (
    <div className="container mx-auto p-6">
      <div className="bg-white shadow-md rounded-lg p-6 mb-6">
        <h2 className="text-3xl font-bold mb-4">School Policy</h2>
        <p className="mb-4">
          Hamilton College of the Bahamas is committed to providing a safe and supportive learning environment for all students. Our policies are designed to ensure that all students have the opportunity to succeed academically and personally.
        </p>
        <h3 className="text-2xl font-bold mb-4">Attendance Policy</h3>
        <p className="mb-4">
          Regular attendance is essential for success in our programs. Students are expected to attend all scheduled classes and participate in all required activities. Absences must be reported to the instructor in advance whenever possible.
        </p>
        <h3 className="text-2xl font-bold mb-4">Academic Integrity</h3>
        <p className="mb-4">
          Academic integrity is a fundamental value of Hamilton College of the Bahamas. Students are expected to uphold the highest standards of academic honesty and integrity. Any form of academic dishonesty, including cheating, plagiarism, and falsification of records, will not be tolerated.
        </p>
        <h3 className="text-2xl font-bold mb-4">Code of Conduct</h3>
        <p className="mb-4">
          All students are expected to conduct themselves in a manner that reflects the values and standards of Hamilton College of the Bahamas. This includes treating others with respect, maintaining a positive and inclusive learning environment, and adhering to all college policies and procedures.
        </p>
        <h3 className="text-2xl font-bold mb-4">Grievance Policy</h3>
        <p className="mb-4">
          Hamilton College of the Bahamas is committed to addressing student concerns and grievances in a fair and timely manner. Students who have a grievance should first attempt to resolve the issue informally with the involved parties. If the issue cannot be resolved informally, students may file a formal grievance with the college administration.
        </p>
      </div>
    </div>
  );
};

export default SchoolPolicy;